import {atom} from "recoil";


export interface IPrintNodePrinter {
    /** PrintNode int id or GoMake Print Manager UUID string. */
    printerId: number | string;
    printerName: string;
    bins: string[];
    label: string;
    isOnline?: boolean;
    isEnabled?: boolean;
}
export const printNodePrintersState = atom<IPrintNodePrinter[]>({
    key: 'printNodePrintersState',
    default: []
})